module.exports = __webpack_public_path__ + "0acc7c2a07553417a79b182ff8e8703b.pdf";